<div *ngIf="horizontalMenu" class="navbar-header d-xl-block d-none">
  <!-- Navbar brand -->
  <ul class="nav navbar-nav flex-row">
    <li class="nav-item">
      <a class="navbar-brand" [routerLink]="['/']">
        <span class="brand-logo">
          <img src="{{ coreConfig.app.appLogoImage }}" alt="brand-logo" width="36" />
        </span>
        <h2 class="brand-text mb-0">{{ coreConfig.app.appName }}</h2>
      </a>
    </li>
  </ul>
  <!--/ Navbar brand -->
</div>

<div class="navbar-container d-flex content">
  <div class="bookmark-wrapper d-flex align-items-center">
    <!-- Menu Toggler | Menu icon will be hidden in case of layout without menu -->
    <ul class="nav navbar-nav d-xl-none" *ngIf="!coreConfig.layout.menu.hidden">
      <li class="nav-item">
        <a class="nav-link menu-toggle" (click)="toggleSidebar('menu')">
          <span [data-feather]="'menu'" [class]="'ficon'"></span>
        </a>
      </li>
    </ul>
    <!--/ Menu Toggler -->
    <!-- Commentez -->
    <ul class="nav navbar-nav align-items-center ml-auto">
      <app-navbar-comm></app-navbar-comm>
    </ul>

    <!--/ Commentez -->
    <!-- Bookmark -->
    <app-navbar-bookmark></app-navbar-bookmark>
    <!--/ Bookmark -->
  </div>
  <ul class="nav navbar-nav align-items-center ml-auto">
    <!-- Language selection -->
    <li ngbDropdown class="nav-item dropdown dropdown-language">
      <a class="nav-link dropdown-toggle" id="dropdown-flag" ngbDropdownToggle>
        <i class="flag-icon flag-icon-{{ languageOptions[_translateService.currentLang].flag }}"></i
        ><span class="selected-language">{{
          displayLang(languageOptions[_translateService.currentLang].tr)
        }}</span></a
      >
      <div ngbDropdownMenu aria-labelledby="dropdown-flag">
        <a
          *ngFor="let lang of _translateService.getLangs()"
          ngbDropdownItem
          (click)="setLanguage(lang)"
        >
          <i class="flag-icon flag-icon-{{ languageOptions[lang].flag }}"></i
          >{{ displayLang(languageOptions[lang].tr) }}
        </a>
      </div>
    </li>
    <!--/ Language selection -->

    <!-- Toggle skin -->
    <li class="nav-item d-none d-lg-block">
      <a class="nav-link nav-link-style btn" (click)="toggleDarkSkin()">
        <span
          [ngClass]="currentSkin === 'dark' ? 'icon-sun' : 'icon-moon'"
          class="ficon font-medium-5 feather"
        ></span>
      </a>
    </li>
    <!--/ Toggle skin -->

    <!--
    <app-navbar-search></app-navbar-search>
    Search -->

    <!-- Notification -->
    <app-navbar-notification></app-navbar-notification>
    <!--/ Notification -->

    <!-- Support message -->
    <li class="nav-item d-none d-lg-block">
      <a
        placement="bottom"
        ngbTooltip="{{ 'Dash.sc' | translate }}"
        class="nav-link"
        id="navbarNotificationDropdown"
        routerLink="/reclamation"
        ><i class="ficon" data-feather="mail"></i
        ><span class="badge badge-pill badge-danger badge-up"> {{ nbr }}</span>
      </a>
    </li>
    <!--/ Support message -->

    <!-- User Dropdown -->
    <li ngbDropdown class="nav-item dropdown-user ml-2">
      <a
        class="nav-link dropdown-toggle dropdown-user-link"
        id="dropdown-user"
        ngbDropdownToggle
        id="navbarUserDropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <ng-container *ngIf="this.currentUser">
          <span class="avatar"
            ><img class="round" [src]="avatarImage" alt="avatar" height="40" width="40" /><span
              class="avatar-status-online"
            ></span
          ></span>
        </ng-container>
      </a>
      <div
        ngbDropdownMenu
        aria-labelledby="navbarUserDropdown"
        class="dropdown-menu dropdown-menu-right"
      >
        <a ngbDropdownItem [routerLink]="['/pages/account-settings']" *ngIf="this.currentUser">
          <div class="media">
            <div class="avatar mr-1">
              <img class="round" [src]="avatarImage" alt="avatar" height="25" width="25" />
              <span class="avatar-status-online"></span>
            </div>
            <div class="media-body">
              <h6>{{ this.currentUser.FirstName }}</h6>
              <h6>{{ this.currentUser.LastName }}</h6>
            </div>
          </div>
        </a>
        <a ngbDropdownItem (click)="showMarchandMenu()" *ngIf="this.marchand">
          <div class="media">
            <div class="avatar mr-1">
              <img class="round" [src]="avatarImage" alt="avatar" height="25" width="25" />
              <span class="avatar-status-online"></span>
            </div>
            <div class="media-body">
              <h6>{{ marchand.nom_enseigne}}</h6>
            </div>
          </div>
        </a>
        <a ngbDropdownItem [routerLink]="['/pages/account-settings']"
          ><span [data-feather]="'settings'" [class]="'mr-50'"></span
          >{{ "Global.param" | translate }}</a
        ><a ngbDropdownItem [routerLink]="['/pages/faq']"
          ><span [data-feather]="'help-circle'" [class]="'mr-50'"></span
          >{{ "Global.faq" | translate }}</a
        >
        <div class="dropdown-divider"></div>
        <a ngbDropdownItem (click)="logout()"
          ><span [data-feather]="'power'" [class]="'mr-50'"></span>
          {{ "Global.deco" | translate }}</a
        >
      </div>
    </li>
    <!--/ User Dropdown -->
  </ul>
</div>
